type Config = {
  apiUrl: string;
};

const config: Config = {
  apiUrl: process.env.REACT_APP_API_ROOT || 'http://localhost:8080',
};

export default config;
